const FORM_TOKEN_KEY_PREFIX = "formAccessToken:";

export function rememberFormAccessToken(formId: number, token: string) {
    if (!formId || !token) return;
    sessionStorage.setItem(`${FORM_TOKEN_KEY_PREFIX}${formId}`, token);
}

export function getFormAccessToken(formId?: number | string | null): string {
    const queryToken = new URLSearchParams(window.location.search).get("token");
    if (queryToken) {
        if (formId) rememberFormAccessToken(Number(formId), queryToken);
        return queryToken;
    }

    if (formId == null || formId === "") return "";

    return sessionStorage.getItem(`${FORM_TOKEN_KEY_PREFIX}${Number(formId)}`) ?? "";
}

export function readCreatedForm(result: any): { id: number; token: string } {
    const rawId = typeof result === "number" || typeof result === "string" ? result : (result?.id ?? result?.Id);
    const id = Number(rawId);
    const token = String(result?.token ?? result?.Token ?? "");
    if (id) rememberFormAccessToken(id, token);
    return { id, token };
}

export function withFormAccessToken(path: string, formId: number, token?: string): string {
    const accessToken = token || getFormAccessToken(formId);
    if (!accessToken) return path;

    rememberFormAccessToken(formId, accessToken);
    const separator = path.includes("?") ? "&" : "?";
    return `${path}${separator}token=${encodeURIComponent(accessToken)}`;
}

export function appendFormAccessToken(formData: FormData, formId?: number | string | null) {
    const accessToken = getFormAccessToken(formId);
    if (accessToken) formData.append("token", accessToken);
}
